/*
 * @Description:
 * @Author: xiawenlong
 * @Date: 2021-03-22 19:09:00
 * @LastEditors: xiawenlong
 * @LastEditTime: 2021-06-30 09:44:36
 */
import Layout from '@/layout'

export default [
  {
    path: '/study',
    component: Layout,
    children: [
      {
        path: '/study',
        name: 'Study',
        component: () => import(/*webpackChunkName:'Study'*/ '@/views/study'),
        meta: { title: '学习中心', homePage: true },
      },
    ],
  },
  {
    path: '/study/setting',
    name: 'StudySetting',
    component: () => import(/*webpackChunkName:'StudySetting'*/ '@/views/study/StudySetting/index'),
    meta: { title: '设置' },
  },
  {
    path: '/study/setting/account',
    name: 'StudySettingAccount',
    component: () =>
      import(
        /*webpackChunkName:'StudySettingAccount'*/ '@/views/study/StudySetting/StudySettingAccount'
      ),
    meta: { title: '账号设置' },
  },
  {
    path: '/study/setting/video',
    name: 'StudySettingVideo',
    component: () =>
      import(
        /*webpackChunkName:'StudySettingVideo'*/ '@/views/study/StudySetting/StudySettingVideo'
      ),
    meta: { title: '视频设置' },
  },
  {
    path: '/study/setting/help',
    name: 'StudySettingHelp',
    component: () =>
      import(/*webpackChunkName:'StudySettingHelp'*/ '@/views/study/StudySetting/StudySettingHelp'),
    meta: { title: '帮助手册' },
  },
  {
    path: '/study/about',
    name: 'StudyAbout',
    component: () => import(/*webpackChunkName:'StudyAbout'*/ '@/views/study/About'),
    meta: { title: '关于' },
  },
  {
    path: '/study/order',
    name: 'StudyOrder',
    component: () => import(/*webpackChunkName:'StudyOrder'*/ '@/views/study/StudyOrder/index'),
    meta: { title: '我的订单' },
  },
  {
    path: '/study/order/:orderId',
    name: 'StudyOrderDetail',
    component: () =>
      import(/*webpackChunkName:'StudyOrderDetail'*/ '@/views/study/StudyOrder/StudyOrderDetail'),
    meta: { title: '订单详情' },
  },
]
